import { IResultadoCorrida } from "interfaces/resultadoCorrida";
import formWiclax from "./formWiclax";
import { normalizeString } from "helpers/normalizeString";

const { filenamePdf, filenameWiclax, urllink } = formWiclax;

const initicalValueWiclax = (selectedEvento?: IResultadoCorrida) => {
  return {
    [filenamePdf.name]: "",
    [filenameWiclax.name]: selectedEvento?.resultado?.filenameWiclax
      ? selectedEvento?.resultado?.filenameWiclax.split(".")[0]
      : normalizeString(selectedEvento?.titulo),
    [urllink.name]: selectedEvento?.resultado?.urllink || "",
  };
};

export { initicalValueWiclax };
